import { createAsyncThunk } from '@reduxjs/toolkit';
import axiosInstance from 'utils/axios';

// GET ALL CONTACT US
export const getAllContactUs = createAsyncThunk('contactUs/getAllContactUs', async (__, thunkAPI) => {
  try {
    const response = await axiosInstance.get(`/contact`);
    return response.data;
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response.data);
  }
});

// GET CONTACT US DETAIL BY ID
export const getDetailContactUs = createAsyncThunk('detailContactUs/getDetailContactUs', async (id, thunkAPI) => {
  try {
    const response = await axiosInstance.get(`/contact/${id}`);
    return response.data;
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response.data);
  }
});

// CREATE NEW CONTACT US
export const createNewContactUs = createAsyncThunk('contactUs/createNewContactUs', async (payload, thunkAPI) => {
  try {
    const response = await axiosInstance.post(`/contact`, { ...payload });

    thunkAPI.dispatch(getAllContactUs());

    return response.data;
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response.data);
  }
});

// DELETE CONTACT US
export const deleteConctactUs = createAsyncThunk('contactUs/deleteConctactUs', async (id, thunkAPI) => {
  try {
    const response = await axiosInstance.delete(`/contact/${id}`);
    thunkAPI.dispatch(getAllContactUs());
    return response.data;
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response.data);
  }
});
